















import { Component, Vue } from 'vue-property-decorator';
import BaseModal from '@/components/atoms/BaseModal.vue';
import MenuBuilding from '@/components/organisms/MenuBuilding.vue';
import { Building, Catalogue } from '@/types';
import { DoceboCatalogueView } from '@/lib/DoceboAPI';

@Component({
  components: {
    BaseModal,
    MenuBuilding,
  },
})
export default class QuickNavigation extends Vue {
  private get buildings(): Building[] {
    const buildings: Building[] = this.$store.getters[
      'buildings/getConditionalBuildings'
    ]().filter((building: Building) => !building.hiddenFromQuickNavigation);
    return buildings.sort((a, b) => {
      // Get conditional catalogues for each building
      const cataloguesA: Catalogue[] = this.$store.getters[
        'catalogues/getConditionalCataloguesForBuilding'
      ](a.id);
      const cataloguesB: Catalogue[] = this.$store.getters[
        'catalogues/getConditionalCataloguesForBuilding'
      ](b.id);

      // Find the mandatory catalogue if present
      const mandatoryCatalogueA: Catalogue | undefined = cataloguesA.find(
        (catalogue: Catalogue) => catalogue.mandatory
      );
      const mandatoryCatalogueB: Catalogue | undefined = cataloguesB.find(
        (catalogue: Catalogue) => catalogue.mandatory
      );
      // If no mandatory catalogue then dont worry, this won't be displayed (or occur)
      if (!mandatoryCatalogueA || !mandatoryCatalogueB) return 0;
      // Get titles of mandatory catalogues
      const catalogueViewA: DoceboCatalogueView = this.$store.state.catalogues
        .catalogueViews[mandatoryCatalogueA.doceboCatalogueId];
      const catalogueViewB: DoceboCatalogueView = this.$store.state.catalogues
        .catalogueViews[mandatoryCatalogueB.doceboCatalogueId];
      const titleA = catalogueViewA.extra_data.name.toLowerCase();
      const titleB = catalogueViewB.extra_data.name.toLowerCase();
      // Sort alphabetically
      if (titleA < titleB) return -1;
      if (titleB > titleA) return 1;
      return 0;
    });
  }

  private gotoBuilding(building: Building) {
    const catalogues: Catalogue[] = this.$store.getters[
      'catalogues/getConditionalCataloguesForBuilding'
    ](building.id);
    this.$router
      .push({
        name: 'Building',
        params: {
          buildingId: building.id,
          catalogueId: catalogues[0].doceboCatalogueId.toString(),
        },
      })
      .catch((e) => {
        console.assert(true, e);
      });
  }
}
